/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.index.page.copilot.rpc.ViewGenerationService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const generateViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateView',
  auth: 'app',
  fingerprint: 'ypZK0ooGSpkdEfe_uSsCipwP6LXzGzX8',
  na1Only: false
};
export const generateViewDebugRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewDebug',
  auth: 'app',
  fingerprint: 'ypZK0ooGSpnZOiqQXknd1pwP6LXzGzX8',
  na1Only: false
};
export const generateAndCreateViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateAndCreateView',
  auth: 'app',
  fingerprint: 'ypZK0ooGSpnLJOS7CArnQpwP6LXzGzX8',
  na1Only: false
};
export const generateDefaultViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateDefaultView',
  auth: 'app',
  fingerprint: '_XeNxIBErSwdEfe_uSsCipwP6LXzGzX8',
  na1Only: false
};
export const generateDefaultViewDebugRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateDefaultViewDebug',
  auth: 'app',
  fingerprint: '_XeNxIBErSzZOiqQXknd1pwP6LXzGzX8',
  na1Only: false
};
export const generateAndCreateDefaultViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateAndCreateDefaultView',
  auth: 'app',
  fingerprint: '_XeNxIBErSzLJOS7CArnQpwP6LXzGzX8',
  na1Only: false
};
export const regenerateViewRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'regenerateView',
  auth: 'app',
  fingerprint: 'oZVeZIFthCsdEfe_uSsCipwP6LXzGzX8',
  na1Only: false
};
export const generateViewWithCombinedLlmModulesRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewWithCombinedLlmModules',
  auth: 'app',
  fingerprint: 'ypZK0ooGSpkdEfe_uSsCipwP6LXzGzX8',
  na1Only: false
};
export const generateViewWithCombinedLlmModulesDebugRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewWithCombinedLlmModulesDebug',
  auth: 'app',
  fingerprint: 'ypZK0ooGSpnZOiqQXknd1pwP6LXzGzX8',
  na1Only: false
};
export const generateViewAndCreateWithCombinedLlmModulesRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewAndCreateWithCombinedLlmModules',
  auth: 'app',
  fingerprint: 'ypZK0ooGSpnLJOS7CArnQpwP6LXzGzX8',
  na1Only: false
};
export const generateViewAndUpdateWithCombinedLlmModulesRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewAndUpdateWithCombinedLlmModules',
  auth: 'app',
  fingerprint: '2Jr3CiAoMRzLJOS7CArnQpwP6LXzGzX8',
  na1Only: false
};
export const generateViewWithoutSaveWithCombinedLlmModulesRpc = {
  serviceName: 'com.hubspot.index.page.copilot.rpc.ViewGenerationService',
  rpcName: 'generateViewWithoutSaveWithCombinedLlmModules',
  auth: 'app',
  fingerprint: 'ypZK0ooGSpm3YdxfflDEPJwP6LXzGzX8',
  na1Only: false
};